import 'slick-carousel';

const $accountGiftSlider = $('.js-account-gift-slider');
const $accountGiftSliderPrev = $('.js-account-gifts-slider-prev');
const $accountGiftSliderNext = $('.js-account-gifts-slider-next');

const generalSlider = {
  initialize() {
    if ($accountGiftSlider.length) {
      this.create();
    }
  },

  create() {
    $accountGiftSlider.each((i, slider) => {
      const $slider = $(slider);

      $accountGiftSliderPrev.on('click', () => {
        $slider.slick('slickPrev');
      });

      $accountGiftSliderNext.on('click', () => {
        $slider.slick('slickNext');
      });

      const config = {
        rows: 0,
        arrows: false,
        mobileFirst: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      };

      $slider.slick(config);
    });
  },
};

export default generalSlider;
